import { createTheme } from '@mui/material/styles';

export const ThemeDefault = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#e51b24',
    },
  },
});